
import { defineComponent, reactive, toRefs, watch, onMounted } from 'vue'
import nineDirections from '@/api/nineDirections'
import Card from './card.vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { gotoClientLogin } from '@/utils/stock'

interface pageDataType {
  courseList: any[]
  subjectName: string
  subjectIntro: string
  theme: string
  loading: boolean
  pageNo: number
  pageSize: number
  breadcrumb: Array<{ title: string }>
}

export default defineComponent({
  components: { Card },
  setup() {
    const route = useRoute()
    const pageData: pageDataType = reactive({
      courseList: [],
      subjectName: (route.query.subjectName || '').toString(),
      subjectIntro: (route.query.subjectIntro || '').toString(),
      theme: (route.query.theme || '').toString() || 'light',
      loading: false,
      pageNo: 1,
      pageSize: 100,
      breadcrumb: [
        { title: '精品课程' },
        { title: '专题详情' }
      ]
    })

    function getCourseList() {
      pageData.loading = true
      const subjectCode = route.query.subjectCode as string
      nineDirections.schoolCourseAllPage({
        subjectCode: subjectCode,
        pageNo: pageData.pageNo,
        pageSize: pageData.pageSize
      }, {
        username: route.query.userName as string || '',
        token: route.query.token as string || ''
      }).then((res: any) => {
        pageData.loading = false
        if (res.code === 1 && res.data) {
          pageData.courseList = formatCourseList(res.data.data || [])
        }
      }).catch(() => {
        pageData.loading = false
      })
    }

    function formatCourseList(list: any[]) {
      return list.map((course: any) => ({
        courseNo: course.courseNo,
        courseName: course.name,
        coverImage: course.coverImage,
        mainTeacherName: course.mainTeacherName,
        introduction: course.introductionImage,
        lessonNo: null,
        chapterNo: null,
        subCourseNo: null
      }))
    }

    function jumpToCourse(p: { courseNo: string; lessonNo?: string }) {
      if (!route.query.token) {
        gotoClientLogin()
        return
      }
      router.push({
        name: 'coursedetail',
        query: {
          ...route.query,
          courseNo: p.courseNo
        }
      })
    }

    function goBack() {
      router.push({
        name: 'excellentcourse',
        query: { ...route.query }
      })
    }

    onMounted(() => {
      getCourseList()
    })

    watch(
      () => route.query.theme,
      () => {
        pageData.theme = route.query.theme as string
      }
    )

    return {
      ...toRefs(pageData),
      jumpToCourse,
      goBack
    }
  }
})
